<template>
  <div class="col-lg-12 col-xl-3 col-md-12 col-sm-12">
    <div class="card">
      <div class="list-group list-group-transparent mb-0 mail-inbox">
        <!-- <div class="mt-4 mb-4 ml-4 mr-4 text-center">
          <span class="btn-secondary btn-lg btn-block">简历信息</span>
        </div> -->
        <div class="">
          &nbsp;
        </div>
        <a class="list-group-item list-group-item-action d-flex align-items-center" v-bind:class="[editIndex==1?'active':'']" href="javascript:void(0)"
           v-on:click="goPage(1)">
          <span class="icon mr-3"><i class="fe fe-user"></i></span>个人信息<span class="ml-auto badge badge-default">必填</span>
        </a>
        <a class="list-group-item list-group-item-action d-flex align-items-center" v-bind:class="[editIndex==2?'active':'']"  href="javascript:void(0)"
           v-on:click="goPage(2)">
          <span class="icon mr-3"><i class="fe fe-send"></i></span>求职意向<span class="ml-auto badge badge-default">必填</span>
        </a>
        <a class="list-group-item list-group-item-action d-flex align-items-center" v-bind:class="[editIndex==3?'active':'']" href="javascript:void(0)"
           v-on:click="goPage(3)">
          <span class="icon mr-3"><i class="fe fe-list"></i></span>工作经历<span class="ml-auto badge badge-default">必填</span>
        </a>
        <a class="list-group-item list-group-item-action d-flex align-items-center" v-bind:class="[editIndex==4?'active':'']" href="javascript:void(0)"
           v-on:click="goPage(4)">
          <span class="icon mr-3"><i class="icon-graduation"></i></span>教育经历<span class="ml-auto badge badge-default">必填</span>
        </a>
        <a class="list-group-item list-group-item-action d-flex align-items-center" v-bind:class="[editIndex==5?'active':'']" href="javascript:void(0)"
           v-on:click="goPage(5)">
          <span class="icon mr-3"><i class="fe fe-book-open"></i></span>培训经历
        </a>
        <a class="list-group-item list-group-item-action d-flex align-items-center" v-bind:class="[editIndex==6?'active':'']" href="javascript:void(0)"
           v-on:click="goPage(6)">
          <span class="icon mr-3"><i class="fe fe-star"></i></span>语言能力
        </a>
        <a class="list-group-item list-group-item-action d-flex align-items-center" v-bind:class="[editIndex==7?'active':'']" href="javascript:void(0)"
           v-on:click="goPage(7)">
          <span class="icon mr-3"><i class="fe fe-award"></i></span>专业技能
        </a>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <h6 class="card-title">温馨提示</h6>
        <p class="card-text">
        </p>
        <div class="media-list">
          <div class="media-body">
            <h6 class="text-dark mb-0">完善全部简历，将会更高几率获得心仪的工作哦</h6>
          </div>
       </div>
      </div>
    </div>
  </div>
</template>

<script>
    import {getMyCvView} from "@/api/cv";
    import Toastr from "toastr2";
    import Swal from 'sweetalert2'
    export default {
        name: "CvEditBar",
        data() {
            return {
                basicId: "",
                from: "",
                editIndex:1,
                currentIsEditPage:false
            }
        },
        mounted() {
            this.basicId = this.$route.query.basicId;
            this.from = this.$route.query.from;
            console.log("初始："+this.editIndex)
            //获取初始路由
            this.checkCurrentRouter(this.$route.path);
        },
        watch: {
            // 利用watch方法检测路由变化：
            $route(to, from) {
                this.checkCurrentRouter(this.$route.path);
            }
        },
        methods: {
            goPage(index){
                if (this.from == 'edit' && this.basicId != null && this.basicId != '') {
                    if(index!=this.editIndex){
                        const that=this;
                        if(this.currentIsEditPage){
                            Swal.fire({
                                title: '确定是否已保存信息?',
                                text: "未保存的信息将丢失!",
                                type: 'warning',
                                showCancelButton: true,
                                confirmButtonColor: '#9ac043',
                                //cancelButtonColor: '#d33',
                                confirmButtonText: '确定',
                                cancelButtonText: '取消'
                            }).then(function(isConfirm) {
                                if (isConfirm.value) {
                                    if(index==1){
                                        that.editBaseInfo();
                                    }else if(index==2){
                                        that.editWorkRequired();
                                    }else if(index==3){
                                        that.editWorkExperience();
                                    }else if(index==4){
                                        that.editEduExperience();
                                    }else if(index==5){
                                        that.editTrainExperience();
                                    }else if(index==6){
                                        that.editLanguageAbility();
                                    }else if(index==7){
                                        that.editExtSkill();
                                    }
                                }
                            });
                        }else {
                            if(index==1){
                                that.editBaseInfo();
                            }else if(index==2){
                                that.editWorkRequired();
                            }else if(index==3){
                                that.editWorkExperience();
                            }else if(index==4){
                                that.editEduExperience();
                            }else if(index==5){
                                that.editTrainExperience();
                            }else if(index==6){
                                that.editLanguageAbility();
                            }else if(index==7){
                                that.editExtSkill();
                            }
                        }
                    }
                }else {
                    const toast = new Toastr()
                    toast.warning("请先填写基本信息");
                }
            },
            //基本信息
            editBaseInfo() {
                this.editIndex=1;
                this.basicId = this.$route.query.basicId;
                this.from = this.$route.query.from;
                //获取简历基本信息
                getMyCvView(this.basicId).then(response => {
                    let bf = response.baseInfo;
                    if (bf != null) {
                        this.$router.push({
                            path: "/cv/cv_edit",
                            query: {basicId: this.basicId,from:"edit"}
                        })
                    }else {
                        this.$router.push({
                            path: `/cv/cv_edit/base_info_edit`,
                            query:{from:"add"}
                        })
                    }
                }).catch(error => {
                })
            },
            //工作意向
            editWorkRequired() {
                this.editIndex=2;
                this.basicId = this.$route.query.basicId;
                this.from = this.$route.query.from;
                //获取简历基本信息
                getMyCvView(this.basicId).then(response => {
                    let wd = response.workRequired;
                    if (wd != null) {
                        this.$router.push({
                            path: "/cv/cv_edit/work_required_view",
                            query: {basicId: this.basicId,from:"edit"}
                        })
                    }else {
                        this.$router.push({
                            path: "/cv/cv_edit/work_required_edit",
                            query: {basicId: this.basicId,from:"edit",showCancelButton:"false"}
                        })
                    }
                }).catch(error => {
                })
            },
            //工作经验
            editWorkExperience() {
                this.editIndex=3;
                this.basicId = this.$route.query.basicId;
                this.from = this.$route.query.from;
                //获取简历基本信息
                getMyCvView(this.basicId).then(response => {
                    let we = response.workExpirenceList;
                    if (we != null) {
                        this.isEditWorkExpirence = true;
                        this.$router.push({
                            path: "/cv/cv_edit/work_experience_view",
                            query: {basicId: this.basicId,from:"edit"}
                        })
                    }else {
                        this.$router.push({
                            path: "/cv/cv_edit/work_experience_edit",
                            query: {basicId: this.basicId,from:"edit",showCancelButton:"false"}
                        })
                    }
                }).catch(error => {
                })
            },
            //教育经历
            editEduExperience() {
                this.editIndex=4;
                this.basicId = this.$route.query.basicId;
                this.from = this.$route.query.from;
                //获取简历基本信息
                getMyCvView(this.basicId).then(response => {
                    let ee = response.educationExpirenceList;
                    if (ee != null) {
                        this.$router.push({
                            path: "/cv/cv_edit/edu_experience_view",
                            query: {basicId: this.basicId,from:"edit"}
                        })
                    }else {
                        this.$router.push({
                            path: "/cv/cv_edit/edu_experience_edit",
                            query: {basicId: this.basicId,from:"edit",showCancelButton:"false"}
                        })
                    }
                }).catch(error => {
                })
            },
            //培训经历
            editTrainExperience() {
                this.editIndex=5;
                this.basicId = this.$route.query.basicId;
                this.from = this.$route.query.from;
                //获取简历基本信息
                getMyCvView(this.basicId).then(response => {
                    let trainingExpirenceList = response.trainingExpirenceList;
                    if (trainingExpirenceList != null) {
                        this.$router.push({
                            path: "/cv/cv_edit/train_experience_view",
                            query: {basicId: this.basicId,from:"edit"}
                        })
                    }else {
                        this.$router.push({
                            path: "/cv/cv_edit/train_experience_edit",
                            query: {basicId: this.basicId,from:"edit",showCancelButton:"false"}
                        })
                    }
                }).catch(error => {
                })
            },
            //语言能力
            editLanguageAbility() {
                this.editIndex=6;
                this.basicId = this.$route.query.basicId;
                this.from = this.$route.query.from;
                //获取简历基本信息
                getMyCvView(this.basicId).then(response => {
                    let la = response.languageAbilityList;
                    if (la != null) {
                        this.$router.push({
                            path: "/cv/cv_edit/language_ability_view",
                            query: {basicId: this.basicId,from:"edit"}
                        })
                    }else {
                        this.$router.push({
                            path: "/cv/cv_edit/language_ability_edit",
                            query: {basicId: this.basicId,from:"edit",showCancelButton:"false"}
                        })
                    }
                }).catch(error => {
                })
            },
            //专业技能
            editExtSkill() {
                this.editIndex=7;
                this.basicId = this.$route.query.basicId;
                this.from = this.$route.query.from;
                //获取简历基本信息
                getMyCvView(this.basicId).then(response => {
                    let es = response.extskillList;
                    if (es != null) {
                        this.$router.push({
                            path: "/cv/cv_edit/ext_skill_view",
                            query: {basicId: this.basicId,from:"edit"}
                        })
                    }else {
                        this.$router.push({
                            path: "/cv/cv_edit/ext_skill_edit",
                            query: {basicId: this.basicId,from:"edit",showCancelButton:"false"}
                        })
                    }
                }).catch(error => {
                })
            },
            checkCurrentRouter(routePath){
                //console.log("当前路由："+routePath);
                this.currentIsEditPage=routePath.endsWith("edit");
                //console.log("当前是否编辑页："+this.currentIsEditPage)
                if(routePath.endsWith("base_info_view")||routePath.endsWith("base_info_edit")){
                    this.editIndex=1;
                }else if(routePath.endsWith("work_required_view")||routePath.endsWith("work_required_edit")){
                    this.editIndex=2;
                }else if(routePath.endsWith("work_experience_view")||routePath.endsWith("work_experience_edit")){
                    this.editIndex=3;
                }else if(routePath.endsWith("edu_experience_view")||routePath.endsWith("edu_experience_edit")){
                    this.editIndex=4;
                }else if(routePath.endsWith("train_experience_view")||routePath.endsWith("train_experience_edit")){
                    this.editIndex=5;
                }else if(routePath.endsWith("language_ability_view")||routePath.endsWith("language_ability_edit")){
                    this.editIndex=6;
                }else if(routePath.endsWith("ext_skill_view")||routePath.endsWith("ext_skill_edit")){
                    this.editIndex=7;
                }
            }
        }
    }
</script>

<style scoped>
.list-group-transparent .list-group-item.active{
    background:none;
    color:#90c31f;
}
.list-group-transparent .list-group-item.active::before{
    content: "|";
    color: #90c31f;
    font-size: 20px;
    font-weight: bold;
    position: absolute;
    left: -1px;
}
</style>



// WEBPACK FOOTER //
// src/components/cv/CvEditBar.vue